import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, setToken } from "@/lib/api";
import { toast } from "sonner";

const AdminLogin = () => {
  const [pw, setPw] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { password: pw });
      setToken(data.token);
      toast.success("Benvenuto");
      nav("/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Errore");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen bg-[#f9f8f6] flex items-center justify-center px-6">
      <form
        onSubmit={submit}
        data-testid="admin-login-form"
        className="w-full max-w-md"
      >
        <p className="font-sans text-xs tracking-[0.35em] uppercase text-[#4a4843] mb-3 text-center">
          Studio
        </p>
        <h1 className="font-serif text-5xl text-center text-[#1a1918] tracking-tight font-light mb-2">
          Attraversando
        </h1>
        <p className="font-serif italic text-center text-[#4a4843] mb-12">
          accesso autore
        </p>

        <label className="block font-sans text-xs tracking-[0.3em] uppercase text-[#4a4843] mb-3">
          Password
        </label>
        <input
          data-testid="admin-password-input"
          type="password"
          autoFocus
          value={pw}
          onChange={(e) => setPw(e.target.value)}
          className="w-full bg-transparent border-0 border-b border-[#1a1918] py-3 font-serif text-xl focus:outline-none focus:border-[#d4b886]"
        />

        <button
          type="submit"
          data-testid="admin-login-submit"
          disabled={loading || !pw}
          className="mt-10 w-full bg-[#1a1918] text-[#f9f8f6] hover:bg-[#4a4843] transition-colors py-4 font-sans text-xs tracking-[0.3em] uppercase disabled:opacity-50"
        >
          {loading ? "accesso…" : "entra"}
        </button>
      </form>
    </div>
  );
};

export default AdminLogin;
